import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// react icons
import { TbBrandWhatsapp } from 'react-icons/tb';

import { flexCenter } from 'themes/commonStyles';
import { pink } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

import { colorsAtom,currentUserSessionAtom } from 'library/store';
import { useRecoilState, useRecoilValue } from 'recoil';

export const Logo = () => {

  const navigate = useNavigate();

  const [Colors, setColors] = useRecoilState(colorsAtom);
  const { applicationSetup} = useRecoilValue(currentUserSessionAtom);
  
  return (
    <Box sx={flexCenter}>
      <TbBrandWhatsapp size={24} color={Colors.secondary} />
      <Button key="key-logo-button" sx={{pl:0}}>
        <Typography onClick={() => {navigate(`home`);}}
          sx={{
            ml: 1,
            color: (theme) => theme.palette.secondary.main,
            fontSize: '20px',
            fontWeight: 'bold',
          }}
          component="h3"
          style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
          Nyxis - {applicationSetup.companyName}
        </Typography>
      </Button>
    </Box>
  );
};

